// These are aliases for classification evidence, not an exhaustive genre list.
// Explicit genre/program-type fields may retain other descriptive labels.
const CLASSIFICATIONS = [
    ["SCIENCE FICTION", /\b(?:science[ -]fiction|sci[ -]?fi)\b/i],
    ["FILM NOIR", /\bfilm noir\b/i],
    ["GAME SHOW", /\b(?:game shows?|quiz shows?)\b/i],
    ["TALK SHOW", /\btalk shows?\b/i],
    ["PUBLIC SERVICE", /\bpublic service\b/i],
    ["TV EPISODE", /\b(?:tv|television) episodes?\b/i],
    ["SITCOM", /\b(?:sitcoms?|situation comed(?:y|ies))\b/i],
    ["DOCUMENTARY", /\bdocumentar(?:y|ies)\b/i],
    ["EDUCATIONAL", /\b(?:educat(?:ion|ional)|instructional|classroom)\b/i],
    ["COMMERCIAL", /\bcommercials?\b/i],
    ["ADVERTISING", /\badvertis(?:ing|ement|ements)\b/i],
    ["INDUSTRIAL", /\bindustrial\b/i],
    ["MILITARY", /\bmilitary\b/i],
    ["NEWS", /\b(?:news|newscasts?|newsreels?)\b/i],
    ["CARTOON", /\bcartoons?\b/i],
    ["ANIMATION", /\b(?:animation|animated)\b/i],
    ["WESTERN", /\bwesterns?\b/i],
    ["COMEDY", /\bcomed(?:y|ies)\b/i],
    ["DRAMA", /\bdramas?\b/i],
    ["HORROR", /\bhorror\b/i],
    ["THRILLER", /\bthrillers?\b/i],
    ["MYSTERY", /\bmyster(?:y|ies)\b/i],
    ["CRIME", /\bcrime\b/i],
    ["ADVENTURE", /\badventure\b/i],
    ["ACTION", /\baction\b/i],
    ["ROMANCE", /\b(?:romance|romantic)\b/i],
    ["FANTASY", /\bfantasy\b/i],
    ["MUSICAL", /\bmusicals?\b/i],
    ["MUSIC", /\b(?:music|concerts?)\b/i],
    ["SPORTS", /\bsports?\b/i],
    ["VARIETY", /\bvariety\b/i],
    ["TRAVEL", /\btravel(?:ogue)?s?\b/i],
    ["BIOGRAPHY", /\b(?:biograph(?:y|ies|ical)|biopic)\b/i],
    ["HISTORICAL", /\bhistorical\b/i],
    ["RELIGIOUS", /\breligious\b/i],
    ["EXPERIMENTAL", /\bexperimental\b/i],
    ["SILENT", /\bsilent\b/i],
    ["SHORT", /\bshort(?: film)?s?\b/i],
    ["MOVIE", /\b(?:movies?|feature films?)\b/i],
    ["TELEVISION", /^(?:tv|television)$/i],
    ["PROGRAM", /^program(?:me)?$/i]
];
function tokens(value) {
    return (value ?? "").split(/[;,|]/).map((token) => token.replace(/\s+/g, " ").trim()).filter(Boolean);
}
function sourceTag(value) {
    return /(?:https?:\/\/|www\.|\b[a-z0-9][a-z0-9.-]*\.[a-z]{2,}\b)/i.test(value)
        || /\b(?:fedflix|prelinger|internet archive|ntis|archives?|collections?)\b/i.test(value)
        || /^(?:unknown|unclassified|unspecified|none|n\/a|other|video|moving[ _-]?image)$/i.test(value);
}
/** Keep source/provider tags out of viewer classifications, including legacy rows. */
export function normalizeClassification(value, options = {}) {
    const sourceTokens = new Set([
        ...tokens(options.sourceCollection),
        ...tokens(options.sourceProvider)
    ].map((token) => token.toLowerCase().replace(/[_-]/g, " ")));
    let explicitLabel = null;
    for (const token of tokens(value)) {
        if (sourceTag(token))
            continue;
        const known = CLASSIFICATIONS.find(([, pattern]) => pattern.test(token));
        const matchesSource = sourceTokens.has(token.toLowerCase().replace(/[_-]/g, " "));
        // A collection can itself be named after a genre (e.g. "Western"). Only
        // retain that exact classification, not a provider label such as "Old Movies".
        if (matchesSource && token.toUpperCase() !== known?.[0])
            continue;
        if (known)
            return known[0];
        if (!options.knownOnly && !explicitLabel)
            explicitLabel = token;
    }
    return explicitLabel;
}
